export default __webpack_public_path__ + "static/media/puzzle.70a79c3d.ogg";